:host {
  display: flex;
}